import React, { useState, useRef } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";

// components
import { Avatar, IconButton } from "components/common";
import Popup from "components/ui/Popup";

// assets
import CameraIcon from "assets/image/icon_camera.png";
import IconX from "assets/icons/icon_close_thick_black.svg";

import { patchProfileImg, patchDefaultProfileImg } from "api/user";
import { fetchUserInfo } from "redux/slices/user/userSlice";

const ImagePicker = ({ avatar, setAvatar }) => {
  const dispatch = useDispatch();
  const popupRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { seqPartner, seqPartnerBranch } = useSelector(
    (state) => state.partner
  );

  const handleChange = (e) => {
    popupRef.current.close();

    const uploadFile = e.target.files[0];
    if (uploadFile.size === 0) return;
    if (uploadFile.size < 1000000) {
      const formData = new FormData();
      formData.append("seqPartner", seqPartner);
      formData.append("seqPartnerBranch", seqPartnerBranch);
      formData.append("image", uploadFile);

      patchProfileImg(formData)
        .then((res) => {
          if (res) {
            dispatch(fetchUserInfo());
            setAvatar(URL.createObjectURL(uploadFile));
          }
        })
        .catch((e) => {});
      return;
    }

    const { type } = uploadFile;
    let reader = new FileReader();
    reader.readAsDataURL(uploadFile);
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        // Resize img code
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const resizingFactor =
          img.width > 2000 || img.height > 2000 ? 0.6 : 0.8;
        const originalWidth = img.width;
        const originalHeight = img.height;
        const canvasWidth = originalWidth * resizingFactor;
        const canvasHeight = originalHeight * resizingFactor;
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;

        context.drawImage(img, 0, 0, canvasWidth, canvasHeight);
        context.canvas.toBlob(
          (blob) => {
            const file = new File([blob], uploadFile.name, {
              type: type,
              lastModified: Date.now(),
            });
            const formData = new FormData();
            formData.append("seqPartner", seqPartner);
            formData.append("seqPartnerBranch", seqPartnerBranch);
            formData.append("image", file);

            patchProfileImg(formData)
              .then((res) => {
                if (res) {
                  dispatch(fetchUserInfo());
                  setAvatar(URL.createObjectURL(file));
                }
              })
              .catch((e) => {});
          },
          type,
          0.6
        );
      };
      img.src = e.target.result;
    };
  };

  const handleReturnToDefault = () => {
    popupRef.current.close();
    patchDefaultProfileImg().then((res) => {
      if (res) {
        dispatch(fetchUserInfo());
        setAvatar("");
      }
    });
  };

  return (
    <Wrapper>
      <AvatarWrapper onClick={() => setOpen(true)}>
        <Avatar src={avatar} size={80} />
        <UploadIcon>
          <img src={CameraIcon} />
        </UploadIcon>
      </AvatarWrapper>

      <Popup
        open={open}
        onClose={setOpen}
        padding="0px"
        preventDefault={false}
        ref={popupRef}
      >
        <PopupWrapper>
          <Title>
            <p>프로필 사진 설정</p>
            <IconButton src={IconX} onClick={() => popupRef.current.close()} />
          </Title>

          <ButtonsWrapper>
            <label htmlFor="upload">
              <p>앨범에서 사진 선택</p>
              <input
                type="file"
                id="upload"
                accept="image/*"
                hidden
                onChange={handleChange}
              />
            </label>

            <button onClick={handleReturnToDefault}>기본 이미지로 변경</button>
          </ButtonsWrapper>
        </PopupWrapper>
      </Popup>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AvatarWrapper = styled.div`
  position: relative;
`;

const UploadIcon = styled.div`
  background-color: transparent;
  width: 30px;
  height: 30px;
  position: absolute;
  top: 50px;
  left: 50px;
`;

const PopupWrapper = styled.div`
  height: 180px;
  padding: 26px 24px 20px 24px;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  p {
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
  }
`;

const ButtonsWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  button,
  label {
    outline: none;
    border: none;
    background-color: inherit;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #26282b;
    font-feature-settings:
      "tnum" on,
      "lnum" on;
  }
  label {
    margin-bottom: 24px;
  }
`;

export default ImagePicker;
